import type { EventMetadata } from './types'
import type { Action } from './actions'

export type State = {
    canonicalURL?: string,
    keywords?: string,
    seoDescription?: string,
    title?: string,
    eventMetadata?: EventMetadata,
    cookiesConsents?: boolean
}

const defaultTitle = process.env.REACT_APP_SITE_NAME || 'BURGER KING® FRANCE'
const initialState: State = {
    keywords: 'burger, king',
    seoDescription: `Site officiel de ${defaultTitle}. Retrouvez toute l’actualité du King, l’ensemble des produits, le plan d’accès aux restaurants, l’histoire de la marque et les offres d’emploi !`,
    title: defaultTitle
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_METADATA':
            const {
                canonicalURL,
                keywords,
                seoDescription,
                title
            } = action.payload
            return {
                ...state,
                canonicalURL,
                keywords,
                seoDescription,
                title
            }
        case 'EVENT_METADATA':
            return {
                ...state,
                eventMetadata: action.payload
            }
        default:
            return state
    }
}
